import { render, staticRenderFns } from "./Puestos.vue?vue&type=template&id=66eb635c&scoped=true"
import script from "./Puestos.vue?vue&type=script&lang=js"
export * from "./Puestos.vue?vue&type=script&lang=js"
import style0 from "./Puestos.vue?vue&type=style&index=0&id=66eb635c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66eb635c",
  null
  
)

export default component.exports